module.exports = __webpack_public_path__ + "fontawesome-webfont-v=4.4.0.dfb02f8f6d0cedc009ee.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/font-awesome/fontawesome-webfont-v=4.4.0.woff
// module id = 701
// module chunks = 2